export type Options = {
    ignoredProperties: string[];
}

export const configOptions: Options = {
    ignoredProperties: []
}
